import { render, staticRenderFns } from "./FunctionWrapper.vue?vue&type=template&id=25a616ea&scoped=true&"
import script from "./FunctionWrapper.vue?vue&type=script&lang=ts&"
export * from "./FunctionWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./FunctionWrapper.vue?vue&type=style&index=0&id=25a616ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a616ea",
  null
  
)

export default component.exports